﻿import * as LogService from '../core/services/logservice/log.service';
import * as HttpDataServiceBase from '../core/httpdataservicebase';
import * as MessageBarService from '../core/services/messageBarService/messageBar.service';
import * as Model from '../models/models';
import {ICachingRepository} from './caching.repository';
import IAppSettings from '../../iApp.settings';
import * as lodash from 'lodash';

export class CodeRepository extends HttpDataServiceBase.DataServiceBase<Model.ICode> implements ICachingRepository {
    static $inject = ['$q', '$http', 'logService', 'appSettings', 'messageBarService'];
    constructor($q: ng.IQService, $http: ng.IHttpService, logger: LogService.ILogService, appSettings: IAppSettings, messageBarService: MessageBarService.MessageBarService) {
        super($q, $http, logger, messageBarService, appSettings.apiPath + '/codes');
        this.appSettings = appSettings;
    }

    private appSettings: IAppSettings;
    private cachedTables: Model.ICodeDictionary = {};

    public getCodesByCodeTypeId(codeTypeId: string): ng.IPromise<any> {
        const url = `${this.appSettings.apiPath}/codetypes/${codeTypeId}/codes`;

        if (codeTypeId in this.cachedTables)
            return this.$q.when(this.cachedTables[codeTypeId]);

        return this.$http.get(url)
            .then((response: ng.IHttpPromiseCallbackArg<Model.ICode[]>) => {
                this.cachedTables[codeTypeId] = response.data;
                return this.successHandler(response);
            })
            .catch((error: ng.IHttpPromiseCallbackArg<any>) => this.errorHandler(error));
    }

    /**
     * @returns A promise that contains a map of the code types, where the key to the map is the CodeTypeId
     * @param codeTypes
     */
    public getCodesByCodeType(codeTypes: string[]): ng.IPromise<any> {

        const codeTables: Model.ICodeDictionary = {};
        const toDownload: string[] = [];

        // we will only download code tables that are not already in the cache
        // separate the code tables that are cached vs. tables that need to be downloaded
        codeTypes.forEach((codeType: string) => {
            if (angular.isDefined(this.cachedTables[codeType]))
                codeTables[codeType] = this.cachedTables[codeType];
            else
                toDownload.push(codeType);
        });

        // only hit the codes endpoint if we have code tables to download
        if (toDownload.length > 0) {
            return this.getCodeBatch(toDownload)
                .then((downloaded: Model.ICodeDictionary) => {
                    lodash.assign(this.cachedTables, downloaded);
                    lodash.assign(codeTables, downloaded);
                    return codeTables;
                });
        }

        // if all the requested code tables were in the cache, just return a fullfulled promise
        return this.$q.when(codeTables);
    }

    private getCodeBatch(codeTypes: string[]): ng.IPromise<any> {
        const url = `${this.appSettings.apiPath}/codeTypes/codes/batch`;
        return this.$http.post(url, codeTypes)
            .then((response: ng.IHttpPromiseCallbackArg<Model.ICodeDictionary>) => this.successHandler(response))
            .catch((error: ng.IHttpPromiseCallbackArg<any>) => this.errorHandler(error));
    }

    public invalidate(): void {
        this.cachedTables = {};
    }
}